// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes marching-ants {
  0% {
    background-position: 0 0, 0 100%, 0 0, 100% 0;
  }
  100% {
    background-position: 20px 0, -20px 100%, 0 -20px, 100% 20px;
  }
}
:root {
  --rc-drag-handle-size: 12px;
  --rc-drag-handle-mobile-size: 24px;
  --rc-drag-handle-bg-colour: rgba(0, 0, 0, 0.2);
  --rc-drag-bar-size: 6px;
  --rc-border-color: rgba(255, 255, 255, 0.7);
  --rc-focus-color: #0088ff;
}

.ReactCrop {
  position: relative;
  display: inline-block;
  cursor: crosshair;
  max-width: 100%;
}
.ReactCrop *, .ReactCrop *::before, .ReactCrop *::after {
  box-sizing: border-box;
}
.ReactCrop--disabled, .ReactCrop--locked {
  cursor: inherit;
}
.ReactCrop__child-wrapper {
  overflow: hidden;
  max-height: inherit;
}
.ReactCrop__child-wrapper > img, .ReactCrop__child-wrapper > video {
  display: block;
  max-width: 100%;
  max-height: inherit;
}
.ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper > img, .ReactCrop:not(.ReactCrop--disabled) .ReactCrop__child-wrapper > video {
  touch-action: none;
}
.ReactCrop:not(.ReactCrop--disabled) .ReactCrop__crop-selection {
  touch-action: none;
}
.ReactCrop__crop-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}
.ReactCrop__crop-selection {
  position: absolute;
  top: 0;
  left: 0;
  transform: translate3d(0, 0, 0);
  cursor: move;
}
.ReactCrop--disabled .ReactCrop__crop-selection {
  cursor: inherit;
}
.ReactCrop--circular-crop .ReactCrop__crop-selection {
  border-radius: 50%;
}
.ReactCrop--circular-crop .ReactCrop__crop-selection::after {
  pointer-events: none;
  content: "";
  position: absolute;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  border: 1px solid var(--rc-border-color);
  opacity: 0.3;
}
.ReactCrop--no-animate .ReactCrop__crop-selection {
  outline: 1px dashed white;
}
.ReactCrop__crop-selection:not(.ReactCrop--no-animate .ReactCrop__crop-selection) {
  animation: marching-ants 1s;
  background-image: linear-gradient(to right, #fff 50%, #444 50%), linear-gradient(to right, #fff 50%, #444 50%), linear-gradient(to bottom, #fff 50%, #444 50%), linear-gradient(to bottom, #fff 50%, #444 50%);
  background-size: 10px 1px, 10px 1px, 1px 10px, 1px 10px;
  background-position: 0 0, 0 100%, 0 0, 100% 0;
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  color: #fff;
  animation-play-state: running;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.ReactCrop__crop-selection:focus {
  outline: 2px solid var(--rc-focus-color);
  outline-offset: -1px;
}
.ReactCrop--invisible-crop .ReactCrop__crop-mask, .ReactCrop--invisible-crop .ReactCrop__crop-selection {
  display: none;
}
.ReactCrop__rule-of-thirds-vt::before, .ReactCrop__rule-of-thirds-vt::after, .ReactCrop__rule-of-thirds-hz::before, .ReactCrop__rule-of-thirds-hz::after {
  content: "";
  display: block;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.4);
}
.ReactCrop__rule-of-thirds-vt::before, .ReactCrop__rule-of-thirds-vt::after {
  width: 1px;
  height: 100%;
}
.ReactCrop__rule-of-thirds-vt::before {
  left: 33.3333%;
  left: 33.3333333333%;
}
.ReactCrop__rule-of-thirds-vt::after {
  left: 66.6666%;
  left: 66.6666666667%;
}
.ReactCrop__rule-of-thirds-hz::before, .ReactCrop__rule-of-thirds-hz::after {
  width: 100%;
  height: 1px;
}
.ReactCrop__rule-of-thirds-hz::before {
  top: 33.3333%;
  top: 33.3333333333%;
}
.ReactCrop__rule-of-thirds-hz::after {
  top: 66.6666%;
  top: 66.6666666667%;
}
.ReactCrop__drag-handle {
  position: absolute;
  width: var(--rc-drag-handle-size);
  height: var(--rc-drag-handle-size);
  background-color: var(--rc-drag-handle-bg-colour);
  border: 1px solid var(--rc-border-color);
}
.ReactCrop__drag-handle:focus {
  background: var(--rc-focus-color);
}
.ReactCrop .ord-nw {
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  cursor: nw-resize;
}
.ReactCrop .ord-n {
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: n-resize;
}
.ReactCrop .ord-ne {
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  cursor: ne-resize;
}
.ReactCrop .ord-e {
  top: 50%;
  right: 0;
  transform: translate(50%, -50%);
  cursor: e-resize;
}
.ReactCrop .ord-se {
  bottom: 0;
  right: 0;
  transform: translate(50%, 50%);
  cursor: se-resize;
}
.ReactCrop .ord-s {
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  cursor: s-resize;
}
.ReactCrop .ord-sw {
  bottom: 0;
  left: 0;
  transform: translate(-50%, 50%);
  cursor: sw-resize;
}
.ReactCrop .ord-w {
  top: 50%;
  left: 0;
  transform: translate(-50%, -50%);
  cursor: w-resize;
}
.ReactCrop__disabled .ReactCrop__drag-handle {
  cursor: inherit;
}
.ReactCrop__drag-bar {
  position: absolute;
}
.ReactCrop__drag-bar.ord-n {
  top: 0;
  left: 0;
  width: 100%;
  height: var(--rc-drag-bar-size);
  transform: translateY(-50%);
}
.ReactCrop__drag-bar.ord-e {
  right: 0;
  top: 0;
  width: var(--rc-drag-bar-size);
  height: 100%;
  transform: translateX(50%);
}
.ReactCrop__drag-bar.ord-s {
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--rc-drag-bar-size);
  transform: translateY(50%);
}
.ReactCrop__drag-bar.ord-w {
  top: 0;
  left: 0;
  width: var(--rc-drag-bar-size);
  height: 100%;
  transform: translateX(-50%);
}
.ReactCrop--new-crop .ReactCrop__drag-bar, .ReactCrop--new-crop .ReactCrop__drag-handle, .ReactCrop--fixed-aspect .ReactCrop__drag-bar {
  display: none;
}
.ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n, .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e, .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s, .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w {
  display: none;
}
@media (pointer: coarse) {
  .ReactCrop .ord-n,
  .ReactCrop .ord-e,
  .ReactCrop .ord-s,
  .ReactCrop .ord-w {
    display: none;
  }
  .ReactCrop__drag-handle {
    width: var(--rc-drag-handle-mobile-size);
    height: var(--rc-drag-handle-mobile-size);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/image-crop/ReactCrop.scss"],"names":[],"mappings":"AAUA;EACE;IACE,6CAAA;EATF;EAWA;IACE,2DAAA;EATF;AACF;AAYA;EACE,2BAAA;EACA,kCAAA;EACA,8CAAA;EACA,uBAAA;EACA,2CAAA;EACA,yBAAA;AAVF;;AAaA;EAGE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;AAZF;AAcE;EAGE,sBAAA;AAdJ;AAiBE;EAEE,eAAA;AAhBJ;AAmBE;EACE,gBAAA;EACA,mBAAA;AAjBJ;AAmBI;EAEE,cAAA;EACA,eAAA;EACA,mBAAA;AAlBN;AAwBM;EAEE,kBAAA;AAvBR;AA0BI;EACE,kBAAA;AAxBN;AA4BE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,oBAAA;AA1BJ;AA6BE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,YAAA;AA3BJ;AA6BI;EACE,eAAA;AA3BN;AA8BI;EACE,kBAAA;AA5BN;AA8BM;EACE,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,wCAAA;EACA,YAAA;AA5BR;AAgCI;EAEE,yBAAA;AA/BN;AAiCI;EACE,2BAAA;EACA,8MAAA;EAEA,uDAAA;EACA,6CAAA;EACA,yDAAA;EACA,WAAA;EACA,6BAAA;EACA,iCAAA;EACA,mCAAA;AAhCN;AAmCI;EACE,wCAAA;EACA,oBAAA;AAjCN;AAoCE;EAEE,aAAA;AAnCJ;AAsCE;EAIE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,0CAAA;AAvCJ;AA2CI;EAEE,UAAA;EACA,YAAA;AA1CN;AA6CI;EACE,cAAA;EACA,oBAAA;AA3CN;AA8CI;EACE,cAAA;EACA,oBAAA;AA5CN;AAiDI;EAEE,WAAA;EACA,WAAA;AAhDN;AAmDI;EACE,aAAA;EACA,mBAAA;AAjDN;AAoDI;EACE,aAAA;EACA,mBAAA;AAlDN;AAsDE;EACE,kBAAA;EACA,iCAAA;EACA,kCAAA;EACA,iDAAA;EACA,wCAAA;AApDJ;AAsDI;EACE,iCAAA;AApDN;AAwDE;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,iBAAA;AAtDJ;AAwDE;EACE,MAAA;EACA,SAAA;EACA,gCAAA;EACA,gBAAA;AAtDJ;AAwDE;EACE,MAAA;EACA,QAAA;EACA,+BAAA;EACA,iBAAA;AAtDJ;AAwDE;EACE,QAAA;EACA,QAAA;EACA,+BAAA;EACA,gBAAA;AAtDJ;AAwDE;EACE,SAAA;EACA,QAAA;EACA,8BAAA;EACA,iBAAA;AAtDJ;AAwDE;EACE,SAAA;EACA,SAAA;EACA,+BAAA;EACA,gBAAA;AAtDJ;AAwDE;EACE,SAAA;EACA,OAAA;EACA,+BAAA;EACA,iBAAA;AAtDJ;AAwDE;EACE,QAAA;EACA,OAAA;EACA,gCAAA;EACA,gBAAA;AAtDJ;AA2DE;EACE,eAAA;AAzDJ;AA4DE;EACE,kBAAA;AA1DJ;AA4DI;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,+BAAA;EACA,2BAAA;AA1DN;AA4DI;EACE,QAAA;EACA,MAAA;EACA,8BAAA;EACA,YAAA;EACA,0BAAA;AA1DN;AA4DI;EACE,SAAA;EACA,OAAA;EACA,WAAA;EACA,+BAAA;EACA,0BAAA;AA1DN;AA4DI;EACE,MAAA;EACA,OAAA;EACA,8BAAA;EACA,YAAA;EACA,2BAAA;AA1DN;AA8DE;EAGE,aAAA;AA9DJ;AAiEE;EAIE,aAAA;AAlEJ;AAqEE;EACE;;;;IAIE,aAAA;EAnEJ;EAsEE;IACE,wCAAA;IACA,yCAAA;EApEJ;AACF","sourcesContent":["@use 'sass:math';\n\n// Query to kick us into \"mobile\" mode with larger drag handles/bars.\n// See: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/pointer\n$mobile-media-query: '(pointer: coarse)' !default;\n\n// Moved to resolve SASS 1.77.7 deprecation warnings\n$antWidth: 10px;\n$doubleAntWidth: 10px * 2;\n\n@keyframes marching-ants {\n  0% {\n    background-position: 0 0, 0 100%, 0 0, 100% 0;\n  }\n  100% {\n    background-position: $doubleAntWidth 0, (-$doubleAntWidth) 100%, 0 (-$doubleAntWidth), 100% $doubleAntWidth;\n  }\n}\n\n:root {\n  --rc-drag-handle-size: 12px;\n  --rc-drag-handle-mobile-size: 24px;\n  --rc-drag-handle-bg-colour: rgba(0, 0, 0, 0.2);\n  --rc-drag-bar-size: 6px; // The invisible grip size of the crop selection edges\n  --rc-border-color: rgba(255, 255, 255, 0.7);\n  --rc-focus-color: #0088ff;\n}\n\n.ReactCrop {\n  $root: &;\n\n  position: relative;\n  display: inline-block;\n  cursor: crosshair;\n  max-width: 100%;\n\n  & *,\n  & *::before,\n  & *::after {\n    box-sizing: border-box;\n  }\n\n  &--disabled,\n  &--locked {\n    cursor: inherit;\n  }\n\n  &__child-wrapper {\n    overflow: hidden;\n    max-height: inherit;\n\n    & > img,\n    & > video {\n      display: block;\n      max-width: 100%;\n      max-height: inherit;\n    }\n  }\n\n  &:not(#{$root}--disabled) {\n    #{$root}__child-wrapper {\n      & > img,\n      & > video {\n        touch-action: none;\n      }\n    }\n    #{$root}__crop-selection {\n      touch-action: none;\n    }\n  }\n\n  &__crop-mask {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    pointer-events: none;\n  }\n\n  &__crop-selection {\n    position: absolute;\n    top: 0;\n    left: 0;\n    transform: translate3d(0, 0, 0);\n    cursor: move;\n\n    .ReactCrop--disabled & {\n      cursor: inherit;\n    }\n\n    .ReactCrop--circular-crop & {\n      border-radius: 50%;\n\n      &::after {\n        pointer-events: none;\n        content: '';\n        position: absolute;\n        top: -1px;\n        right: -1px;\n        bottom: -1px;\n        left: -1px;\n        border: 1px solid var(--rc-border-color);\n        opacity: 0.3;\n      }\n    }\n\n    .ReactCrop--no-animate & {\n      // border: 1px dashed white;\n      outline: 1px dashed white;\n    }\n    &:not(.ReactCrop--no-animate &) {\n      animation: marching-ants 1s;\n      background-image: linear-gradient(to right, #fff 50%, #444 50%), linear-gradient(to right, #fff 50%, #444 50%),\n        linear-gradient(to bottom, #fff 50%, #444 50%), linear-gradient(to bottom, #fff 50%, #444 50%);\n      background-size: $antWidth 1px, $antWidth 1px, 1px $antWidth, 1px $antWidth;\n      background-position: 0 0, 0 100%, 0 0, 100% 0;\n      background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;\n      color: #fff;\n      animation-play-state: running;\n      animation-timing-function: linear;\n      animation-iteration-count: infinite;\n    }\n\n    &:focus {\n      outline: 2px solid var(--rc-focus-color);\n      outline-offset: -1px;\n    }\n  }\n  &--invisible-crop &__crop-mask,\n  &--invisible-crop &__crop-selection {\n    display: none;\n  }\n\n  &__rule-of-thirds-vt::before,\n  &__rule-of-thirds-vt::after,\n  &__rule-of-thirds-hz::before,\n  &__rule-of-thirds-hz::after {\n    content: '';\n    display: block;\n    position: absolute;\n    background-color: rgba(255, 255, 255, 0.4);\n  }\n\n  &__rule-of-thirds-vt {\n    &::before,\n    &::after {\n      width: 1px;\n      height: 100%;\n    }\n\n    &::before {\n      left: 33.3333%;\n      left: calc(100% / 3);\n    }\n\n    &::after {\n      left: 66.6666%;\n      left: calc(100% / 3 * 2);\n    }\n  }\n\n  &__rule-of-thirds-hz {\n    &::before,\n    &::after {\n      width: 100%;\n      height: 1px;\n    }\n\n    &::before {\n      top: 33.3333%;\n      top: calc(100% / 3);\n    }\n\n    &::after {\n      top: 66.6666%;\n      top: calc(100% / 3 * 2);\n    }\n  }\n\n  &__drag-handle {\n    position: absolute;\n    width: var(--rc-drag-handle-size);\n    height: var(--rc-drag-handle-size);\n    background-color: var(--rc-drag-handle-bg-colour);\n    border: 1px solid var(--rc-border-color);\n\n    &:focus {\n      background: var(--rc-focus-color);\n    }\n  }\n\n  .ord-nw {\n    top: 0;\n    left: 0;\n    transform: translate(-50%, -50%);\n    cursor: nw-resize;\n  }\n  .ord-n {\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    cursor: n-resize;\n  }\n  .ord-ne {\n    top: 0;\n    right: 0;\n    transform: translate(50%, -50%);\n    cursor: ne-resize;\n  }\n  .ord-e {\n    top: 50%;\n    right: 0;\n    transform: translate(50%, -50%);\n    cursor: e-resize;\n  }\n  .ord-se {\n    bottom: 0;\n    right: 0;\n    transform: translate(50%, 50%);\n    cursor: se-resize;\n  }\n  .ord-s {\n    bottom: 0;\n    left: 50%;\n    transform: translate(-50%, 50%);\n    cursor: s-resize;\n  }\n  .ord-sw {\n    bottom: 0;\n    left: 0;\n    transform: translate(-50%, 50%);\n    cursor: sw-resize;\n  }\n  .ord-w {\n    top: 50%;\n    left: 0;\n    transform: translate(-50%, -50%);\n    cursor: w-resize;\n  }\n\n  // Use the same specificity as the ords above but just\n  // come after.\n  &__disabled &__drag-handle {\n    cursor: inherit;\n  }\n\n  &__drag-bar {\n    position: absolute;\n\n    &.ord-n {\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: var(--rc-drag-bar-size);\n      transform: translateY(-50%);\n    }\n    &.ord-e {\n      right: 0;\n      top: 0;\n      width: var(--rc-drag-bar-size);\n      height: 100%;\n      transform: translateX(50%);\n    }\n    &.ord-s {\n      bottom: 0;\n      left: 0;\n      width: 100%;\n      height: var(--rc-drag-bar-size);\n      transform: translateY(50%);\n    }\n    &.ord-w {\n      top: 0;\n      left: 0;\n      width: var(--rc-drag-bar-size);\n      height: 100%;\n      transform: translateX(-50%);\n    }\n  }\n\n  &--new-crop &__drag-bar,\n  &--new-crop &__drag-handle,\n  &--fixed-aspect &__drag-bar {\n    display: none;\n  }\n\n  &--fixed-aspect &__drag-handle.ord-n,\n  &--fixed-aspect &__drag-handle.ord-e,\n  &--fixed-aspect &__drag-handle.ord-s,\n  &--fixed-aspect &__drag-handle.ord-w {\n    display: none;\n  }\n\n  @media #{$mobile-media-query} {\n    .ord-n,\n    .ord-e,\n    .ord-s,\n    .ord-w {\n      display: none;\n    }\n\n    &__drag-handle {\n      width: var(--rc-drag-handle-mobile-size);\n      height: var(--rc-drag-handle-mobile-size);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
